import { ValidationResult } from "./interface.validation";

export class CnpjValidator {
  static cnpjFormat(item: any): ValidationResult {
    var CNPJ_REGEXP: any;
    if (item.value) {
      var tt: any = item.value.replace(/[^0-9]/gi, '');

      CNPJ_REGEXP = /([0-9]{14})/;

      if (item.value && !CNPJ_REGEXP.test(tt)) {
        return { "incorrectCnpjFormat": true };
      }
    }

    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/cnpj.validation.ts
 **/